import React from 'react'
import ZaloPay from '../../../../assets/TikTok/logo-zp.svg'
import * as style from './ContentCenter.module.css'

export const BlockImg = ({srcImg, altImg}) => (
    <span className={`${style.borderImg} ${style.tiktokImg}`}> 
        <img width="36px" height="36px" src={srcImg} alt={altImg}/>
    </span>

)

export const ContentCenter = ({bindingInfo, adsInfo}) => {
    const {app_icon_url, merchant_name} = bindingInfo || ''
    const {ads} = adsInfo || {}

    return (
        <section id="contentCenter" style={{marginTop: '75px'}}>
            <div className={style.layoutImgBlock}>
                <BlockImg srcImg={app_icon_url} altImg="logo merchant"/>
                <BlockImg srcImg={ZaloPay} altImg="logo zalopay"/>
            </div>

            <p className={style.textBottomImg}>Liên kết với Zalopay để thanh toán đơn hàng</p>
          {ads?.data && ads?.data?.length > 0 &&
            <div style={{marginTop: '16px', padding: '0 16px'}}>
              <img style={{width: '100%', borderRadius: '8px'}} src={ads.data[0]?.banner_url} //Get first banner only
                   alt={"adsBanner"}/>
            </div>
          }
        </section>
    )
}
